import { site } from '../data/site.js';
import { hasMarketingConsent } from './consent.js';

export function initMetaPixel() {
  const pixelId = site.metaPixelId?.trim();
  if (!hasMarketingConsent() || !/^\d+$/.test(pixelId || '') || window.fbq) return;
  const fbq = function (...args) { fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args); };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  window._fbq = fbq;
  const script = document.createElement('script');
  script.id = 'contdesk-meta-pixel';
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  fbq('consent', 'grant');
  fbq('init', pixelId);
  fbq('track', 'PageView');
}

export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined' || !hasMarketingConsent()) return;
  if (typeof window.fbq === 'function') window.fbq('track', name, params);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
}

export function captureAttribution() {
  if (!hasMarketingConsent()) return {};
  const params = new URLSearchParams(window.location.search);
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];
  const attribution = {};
  keys.forEach(key => { const value = params.get(key); if (value) attribution[key] = value.slice(0, 500); });
  try { if (Object.keys(attribution).length) sessionStorage.setItem('contdesk-attribution', JSON.stringify(attribution)); } catch { /* A medição é opcional. */ }
  return getAttribution();
}

export function getAttribution() {
  if (!hasMarketingConsent()) return {};
  try { return JSON.parse(sessionStorage.getItem('contdesk-attribution') || '{}'); } catch { return {}; }
}
